const products = [
  {
    name: "Cheddar",
    id: "cheddar",
    price: 8.99,
    isNew: false,
    info: `I'm a product detail. I'm a great place to add more information about your product such as sizing, material, care and cleaning instructions. This is also a great space to write what makes this product special and how your customers can benefit from this item. Buyers like to know what they’re getting before they purchase, so give them as much information as possible so they can buy with confidence and certainty.`,
    saleAmount: 0,
  },
  {
    name: "Parmesan",
    id: "parmesan",
    price: 10.99,
    isNew: false,
    info: `I'm a product detail. I'm a great place to add more information about your product such as sizing, material, care and cleaning instructions. This is also a great space to write what makes this product special and how your customers can benefit from this item. Buyers like to know what they’re getting before they purchase, so give them as much information as possible so they can buy with confidence and certainty.`,
    saleAmount: 20,
  },
  {
    name: "Ricotta",
    id: "ricotta",
    price: 12.99,
    isNew: true,
    info: `I'm a product detail. I'm a great place to add more information about your product such as sizing, material, care and cleaning instructions. This is also a great space to write what makes this product special and how your customers can benefit from this item. Buyers like to know what they’re getting before they purchase, so give them as much information as possible so they can buy with confidence and certainty.`,
    saleAmount: 0,
  },
  {
    name: "Danablu",
    id: "danablu",
    price: 11.99,
    isNew: false,
    info: `I'm a product detail. I'm a great place to add more information about your product such as sizing, material, care and cleaning instructions. This is also a great space to write what makes this product special and how your customers can benefit from this item. Buyers like to know what they’re getting before they purchase, so give them as much information as possible so they can buy with confidence and certainty.`,
    saleAmount: 0,
  },
  {
    name: "Bovar Sausages",
    id: "bovarSausages",
    price: 22.99,
    isNew: false,
    info: `I'm a product detail. I'm a great place to add more information about your product such as sizing, material, care and cleaning instructions. This is also a great space to write what makes this product special and how your customers can benefit from this item. Buyers like to know what they’re getting before they purchase, so give them as much information as possible so they can buy with confidence and certainty.`,
    saleAmount: 0,
  },
  {
    name: "Smoked Virgina Bacon",
    id: "bacon",
    price: 12.99,
    isNew: false,
    info: `I'm a product detail. I'm a great place to add more information about your product such as sizing, material, care and cleaning instructions. This is also a great space to write what makes this product special and how your customers can benefit from this item. Buyers like to know what they’re getting before they purchase, so give them as much information as possible so they can buy with confidence and certainty.`,
    saleAmount: 0,
  },
  {
    name: "Salyami",
    id: "salyami",
    price: 8.99,
    isNew: false,
    info: `I'm a product detail. I'm a great place to add more information about your product such as sizing, material, care and cleaning instructions. This is also a great space to write what makes this product special and how your customers can benefit from this item. Buyers like to know what they’re getting before they purchase, so give them as much information as possible so they can buy with confidence and certainty.`,
    saleAmount: 0,
  },
  {
    name: "Bujenina",
    id: "bujenina",
    price: 8.99,
    isNew: false,
    info: `I'm a product detail. I'm a great place to add more information about your product such as sizing, material, care and cleaning instructions. This is also a great space to write what makes this product special and how your customers can benefit from this item. Buyers like to know what they’re getting before they purchase, so give them as much information as possible so they can buy with confidence and certainty.`,
    saleAmount: 20,
  },
  {
    name: "Greek Kalamata Olives",
    id: "olives",
    price: 8.99,
    isNew: false,
    info: `I'm a product detail. I'm a great place to add more information about your product such as sizing, material, care and cleaning instructions. This is also a great space to write what makes this product special and how your customers can benefit from this item. Buyers like to know what they’re getting before they purchase, so give them as much information as possible so they can buy with confidence and certainty.`,
    saleAmount: 20,
  },
  {
    name: "Macarons",
    id: "macarons",
    price: 10.99,
    isNew: false,
    info: `I'm a product detail. I'm a great place to add more information about your product such as sizing, material, care and cleaning instructions. This is also a great space to write what makes this product special and how your customers can benefit from this item. Buyers like to know what they’re getting before they purchase, so give them as much information as possible so they can buy with confidence and certainty.`,
    saleAmount: 0,
  },
  {
    name: "Cakes",
    id: "cakes",
    price: 3.99,
    isNew: false,
    info: `I'm a product detail. I'm a great place to add more information about your product such as sizing, material, care and cleaning instructions. This is also a great space to write what makes this product special and how your customers can benefit from this item. Buyers like to know what they’re getting before they purchase, so give them as much information as possible so they can buy with confidence and certainty.`,
    saleAmount: 0,
  },
];

export default products;
